<template>
  <div class="content">
    <el-row class="content-head">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>考勤管理</el-breadcrumb-item>
            <el-breadcrumb-item>体温健康码记录</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="height:100% !important;" class="aside">
        <p style="text-align:left;padding: 10px;color: red;font-size:10px;">小提示: 访客区域和生活区域不计入日考勤和月考勤</p>
          <!-- 上 -->
          <div class="search-section">
            <div style="display:flex;align-items:center">
              <div style="display:flex;align-items:center;margin-right:20px">
                <span style="margin-right:10px">日期:</span>
                <el-date-picker
                  v-model="search.date"
                  align="right"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <div style="display:flex;align-items:center;margin-right:20px">
                 <span style="margin-right:10px">考勤区域:</span>
                  <el-select
                   v-model="search.inoutType"
                   placeholder="请选择考勤区域"
                   class="select"
                   @change="doFilter"
                   style="width:200px"
                 >
                    <el-option key="0" label="全部" value=""></el-option>
                    <el-option key="1" label="施工区" value="1"></el-option>
                    <el-option key="2" label="生活区" value="2"></el-option>
                    <el-option key="3" label="塔吊区" value="3"></el-option>
                    <el-option key="4" label="升降机区" value="4"></el-option>
                    <el-option key="5" label="访客区" value="5"></el-option>
                 </el-select>
              </div>
               <div style="display:flex;align-items:center;margin-right:20px">
                 <span style="margin-right:10px">进出方向:</span>
                  <el-select
                   v-model="search.status"
                   clearable
                   filterable
                   placeholder="请选择状态"
                   class="select"
                   @change="doFilter"
                   style="width:200px"
                 >
                   <el-option  v-for="item in attendType" :key="item.id" :label="item.label" :value="item.value"></el-option>
                 </el-select>
              </div>
              <div style="display:flex;align-items:center;">
                <el-input
                  v-model="search.personName"
                  placeholder="请输入姓名"
                  clearable
                >
                  <el-button slot="append" icon="el-icon-search" @click="doFilter"></el-button>
                </el-input>
              </div>
              
            </div>
            <!-- <el-button
              type="primary"
              plain
              style="display:flex;align-items:center"
              @click="exportWorker"
            >导出</el-button> -->
             <el-tooltip class="item" effect="dark" content="导出" placement="top-end" v-if="isMenuExit('pro:record:export')">
                <img  class="icon_hover"  @click="exportWorker" src="../../assets/image/export.png" alt="" srcset="">
             </el-tooltip>
          </div>
          <!-- 表格 -->
          <div class="build-table">
            <el-table
              stripe
              :data="listData"
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
              @filter-change="filterTag"
            >
              <template slot="empty">
                <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100" center>
                <template slot-scope="scope">
                  <a style="padding-left:1vw;">{{ (currentPage - 1) * pageSize + scope.$index + 1}}</a>
                </template>
              </el-table-column>
              <el-table-column label="班组">
                <template slot-scope="scope">
                  <span>{{ scope.row.teamName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="姓名">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                  <!-- <div style="display:flex;">
                <img v-if="scope.row.idcardPhoto!=''" :src="scope.row.idcardPhoto" style="width:70px;height:90px;"/>
                <div v-else style="width:70px;height:90px;background: #ddd;display: flex;align-items: center;justify-content: center;">暂无图片</div>
                <div style="padding-left:10px;display:flex;flex-wrap:wrap;width:100px;">
                  <p style="width:100%;text-align: left;padding-top: 10px;">{{ scope.row.name}}</p>
                  <p style="width:100%;text-align: left;padding-top: 10px;">{{ scope.row.idcard}}</p>
                </div>
                  </div>-->
                </template>
              </el-table-column>
              <!-- <el-table-column label="考勤区域">
                <template slot-scope="scope">
                  <span>{{ scope.row.age }}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="考勤区域">
                <template slot-scope="scope">
                  <span>{{ scope.row.inoutTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="设备ID">
                <template slot-scope="scope">
                  <span>{{ scope.row.imei }}</span>
                </template>
              </el-table-column>
              <el-table-column label="现场照片">
                <template slot-scope="scope">
                  <el-image style="width:70px;height:90px;" v-if="scope.row.photoFile!=''" :src="scope.row.photoFile" :preview-src-list="[scope.row.photoFile]"></el-image>
                  <div
                    v-else
                    style="width:70px;height:90px;background: #ddd;display: flex;align-items: center;justify-content: center;"
                  >暂无图片</div>
                </template>
              </el-table-column>
              <el-table-column label="打卡时间" prop="createDate" sortable>
                <template slot-scope="scope">
                  <span>{{ scope.row.date }}</span>
                </template>
              </el-table-column>
              <el-table-column 
                prop="typeName" 
                label="进出方向" 
                :filters="attendType"
                :filter-multiple="false"
                :column-key=" 'aStatus' "
                filter-placement="bottom-end">
                <template slot-scope="scope">
                  <span>{{scope.row.typeName}}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="进出方向">
                <template slot-scope="scope">
                  <span>{{scope.row.typeName}}</span>
                </template>
              </el-table-column> -->
              <el-table-column label="体温" v-if="isMenuExit('pro:tempure:show')">
                <template slot-scope="scope">
                  <span>{{ scope.row.temperature }}</span>
                </template>
              </el-table-column>
              <el-table-column label="健康码状态">
                <template slot-scope="scope">
                  <img :src="scope.row.codeImg" style="height: 6vh" />
                </template>
              </el-table-column>
              <el-table-column label="核酸状态">
                <template slot-scope="scope">
                 <div v-if="scope.row.signImg">
                  <img :src="scope.row.signImg" style="width: 2vw" />
                  <p v-if="scope.row.signType == 1" style="color: #23d715;">已过{{scope.row.timeSpan}}天</p>
                   <p v-else-if="scope.row.signType == 2" style="color: #E32932;">已过{{scope.row.timeSpan}}天</p>
                 </div>
                 <div v-else>
                  <p style="color: #bebebe;">暂无核酸</p>
                 </div>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="personInfo(scope.$index, scope.row)">个人详情</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="el-end">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[3, 5, 10, 20]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
          </div>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      search: {
        //查询
        personName: '',
        date: util.myTime.getCurTime(),
        projectId: '',
        status:'',
        inoutType:''
      },
      listData: [], //表格数据
      dataText: '数据加载中...',
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      attendType: [],

      // types:[],//进出类型
    }
  },
  created() {
    if(util.session.get('roleId')=='4'){
      this.search.projectId = util.session.get('groupId')
    }else{
      this.search.projectId = util.session.get('proId')
    }
  },
  mounted() {
    //this.search.projectId = util.session.get('groupId')
    // if (this.search.projectId == '') {
    //   this.$store.commit('setGroupId')
    //   this.search.projectId = this.$store.state.groupId
    // }
    // console.log(this.search.projectId)
    if(util.session.get('roleId')=='4'){
      this.search.projectId = util.session.get('groupId')
    }else{
      this.search.projectId = util.session.get('proId')
    }
    this.getDict() //获取考勤
    //this.getData()
  },
  methods: {
    //
    getDict() {
      var that = this
      myHttp
        .getDictByType({
          type: 'attend_type'
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.dictList||[]
            for(var i=0;i<list.length;i++){
              list[i].text = list[i].label
            }
            that.attendType = list
            that.getData()
          } else {
            that.$message.error(resp.data.msg)
          }
        })
    },
    //获取类型
    filterSatus(str) {
      var list = this.attendType
      var result = ''
      for (var i = 0; i < list.length; i++) {
        if (str == list[i].value) {
          result = list[i].label
        }
      }
      return result
    },
    // 搜索数据
    doFilter() {
      // this.search.startDate = this.date ? this.date[0] : ''
      // this.search.endDate = this.date ? this.date[1] : ''
      this.currentPage = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    //监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      myHttp.getAttendList(this.search).then(
        function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.pageInfo.list || []
            console.log(list);
            for (var i = 0; i < list.length; i++) {
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              list[i].photoFile = list[i].photoFile && list[i].photoFile != '' ? base.httpCtx + list[i].photoFile : ''
              list[i].typeName = that.filterSatus(list[i].status)

              if (list[i].healthLevel == '1') {
                list[i].codeImg = require('../../assets/image/new/green.png')
              } else if (list[i].healthLevel == '2') {
                list[i].codeImg = require('../../assets/image/new/yellow.png')
              } else if (list[i].healthLevel == '3') {
                list[i].codeImg = require('../../assets/image/new/red.png')
              } else if (
                list[i].healthLevel == '4' ||
                list[i].healthLevel == '0'
              ) {
                list[i].codeImg = require('../../assets/image/new/no.png')
              }

              if(list[i].signName == '阴性') {
                list[i].signType = 1
                list[i].signImg = require('../../assets/image/newAnKang/yin11.png')
              }else if(list[i].signName == '阳性'){
                list[i].signType = 2
                list[i].signImg = require('../../assets/image/newAnKang/yang.png')
              }
              
            }
            that.listData = list
            that.totalItems = resp.data.data.pageInfo.total || 0
            //that.getTypeName()
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    exportWorker() {
      var token = util.session.get('token')
      window.open(
        myHttp.exportAttendList +
          '?projectId=' +
          this.search.projectId +
          '&personName=' +
          this.search.personName +
          '&date=' +
          this.search.date +
          '&accessToken=' +
          token
      )
    },
    // watchInput(e) {
    //   this.search.personName = e
    //   this.getData()
    // }
    personInfo(index,row){
        var port = util.session.get('roleId')
        if(port=='4'){
            this.$router.push({name: 'workerInfo',params: { id: row.personId }})
        }else if(port=='5'||port=='3'){
             this.$router.push({name: 'workerInfoCom',params: { id: row.personId }})
         }  
    
    },
    /**
     * 判断是否展示
     */
    isMenuExit(row){
        var flag = util.common.filterBtnMenu(row)
        return flag
    },

    filterTag(filters) {
        // console.log(filters)
        this.search.status = filters.aStatus[0]
        this.getData()
    }
    
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
}
.search-section {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin: 0px 35px 20px 10px;
  height: 40px;
  justify-content: space-between;
}
.el-end {
  height: 47px;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  text-align: center;
}
.build-table {
  height: calc(100% - 16vh);
  width: 98%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.el-pagination {
  margin: auto;
}
.el-table--fit {
  border-bottom: 1px solid #f5f5f5;
}
.content >>> .el-input-group--append .el-input__inner{
      width: 200px;
    }
</style>